ui-tab-group {
  display: block;

  .tab-group__nav {
    display: inline-block;

    .ui-tab {
      z-index: 11;
    }
  }

  .tab-group__body {
    position: relative;
  }
}
